// extracted by mini-css-extract-plugin
export default {"button":"button_button__86pdz","secondary":"button_secondary__lgkJt","small":"button_small__RiSai"};